import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import PaymentResult from "./PaymentResult";

/**
 * Composant de redirection vers PaymentResult pour assurer la compatibilité en arrière
 * Ce composant est destiné à remplacer PaymentSuccess.js existant
 */
const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Récupérer les paramètres de l'URL actuelle
    const orderParam = searchParams.get("order");
    const statusParam = searchParams.get("status") || "paid"; // Par défaut, considérer comme "paid" si aucun statut

    // Construire la nouvelle URL
    const newUrl = `/payment-result?order=${orderParam}&status=${statusParam}&origin=success`;

    // Rediriger vers la nouvelle URL
    console.log(
      `Redirection de PaymentSuccess vers PaymentResult avec params: ${newUrl}`
    );
    navigate(newUrl, { replace: true });
  }, [searchParams, navigate]);

  // Afficher un loader pendant la redirection
  return (
    <div className="container text-center py-5">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Chargement...</span>
      </div>
      <p className="mt-2">Traitement de votre paiement...</p>
    </div>
  );
};

export default PaymentSuccess;
